/**
 * @generated SignedSource<<c67d9f008d149d00561c030c180ce03b>>
 * @relayHash 214c5e617f238c8b7015f30c80508421
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cfe2e9ea5a1d74783051f43f5ffbc70a65f5989144c200106cd3100cb0cf5f6c

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GoalsDirectoryAggOuterQuery$variables = {
  customFieldContainerId?: string | null;
  workspaceUuid?: string | null;
};
export type GoalsDirectoryAggOuterQuery$data = {
  readonly customfieldHeaderSupport: {
    readonly " $fragmentSpreads": FragmentRefs<"CustomColumnsRegistrationAgg">;
  } | null;
};
export type GoalsDirectoryAggOuterQuery = {
  response: GoalsDirectoryAggOuterQuery$data;
  variables: GoalsDirectoryAggOuterQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "customFieldContainerId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceUuid"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "containerId",
    "variableName": "customFieldContainerId"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  },
  {
    "kind": "Literal",
    "name": "q",
    "value": "entityType = GOAL"
  },
  {
    "kind": "Variable",
    "name": "workspaceUuid",
    "variableName": "workspaceUuid"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "token"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "kind": "ScalarField",
  "name": "type"
},
v5 = [
  (v2/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/)
],
v6 = [
  (v2/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/),
  {
    "kind": "ScalarField",
    "name": "canSetMultipleValues"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "GoalsDirectoryAggOuterQuery",
    "selections": [
      {
        "alias": "customfieldHeaderSupport",
        "args": (v1/*: any*/),
        "concreteType": "TownsquareCustomFieldDefinitionConnection",
        "kind": "LinkedField",
        "name": "projects_customFieldDefinitionSearch",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "CustomColumnsRegistrationAgg"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GoalsDirectoryAggOuterQuery",
    "selections": [
      {
        "alias": "customfieldHeaderSupport",
        "args": (v1/*: any*/),
        "concreteType": "TownsquareCustomFieldDefinitionConnection",
        "kind": "LinkedField",
        "name": "projects_customFieldDefinitionSearch",
        "plural": false,
        "selections": [
          {
            "concreteType": "TownsquareCustomFieldDefinitionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v5/*: any*/),
                    "type": "TownsquareNumberCustomFieldDefinition"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v5/*: any*/),
                    "type": "TownsquareTextCustomFieldDefinition"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v6/*: any*/),
                    "type": "TownsquareTextSelectCustomFieldDefinition"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v6/*: any*/),
                    "type": "TownsquareUserCustomFieldDefinition"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "cfe2e9ea5a1d74783051f43f5ffbc70a65f5989144c200106cd3100cb0cf5f6c",
    "metadata": {},
    "name": "GoalsDirectoryAggOuterQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "b77515aefc4da68a7de54960d6420e08";

export default node;
